const ACCESS_TOKEN_PARAMETER_KEY = 'access_token';
const REFRESH_TOKEN_PARAMETER_KEY = 'refresh_token';
const GRANT_TYPE_PASSWORD_PARAMETER = 'grant_type=password';
const GRANT_TYPE_REFRESH_TOKEN_PARAMETER = 'grant_type=refresh_token';
const CLIENT_ID_PARAMETER = 'client_id=boschung-services'
export const LOGOUT_PARAMETER = 'logout';
export const AZURE_ACCESS_PARAMETER = 'azure_access'

export const REDIRECT_QUERY_PARAMETER_KEY = 'redirect_uri'
export const GENERIC_AUTHENTICATION_PARAMETERS = `?${GRANT_TYPE_PASSWORD_PARAMETER}&${CLIENT_ID_PARAMETER}`;
export const REFRESH_AUTHENTICATION_PARAMETERS = `?${GRANT_TYPE_REFRESH_TOKEN_PARAMETER}&${CLIENT_ID_PARAMETER}`;

export const getRedirectParameters = (accessToken, refreshToken) => `?${ACCESS_TOKEN_PARAMETER_KEY}=${accessToken}&${REFRESH_TOKEN_PARAMETER_KEY}=${refreshToken}`;
const getQueryParam = (key) => new URLSearchParams(window.location.href.split("?")[1]).get(key);

export const getRedirectUriParam = () => getQueryParam(REDIRECT_QUERY_PARAMETER_KEY);
export const getAzureAccessParam = () => getQueryParam(AZURE_ACCESS_PARAMETER);
export const hasParameter = (key) => new URL(window.location.href).searchParams.has(key)